import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseDeleteDiagnosticObjectivePieceProps {
  diagnosticObjectivePieceId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useDeleteDiagnosticObjectivePiece = ({
  diagnosticObjectivePieceId,
  options,
}: UseDeleteDiagnosticObjectivePieceProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteDiagnosticObjectivePiece', diagnosticObjectivePieceId],
    mutationFn: () => {
      return privateAxios.delete(`/maintenance/diagnostic_objective_pieces/${diagnosticObjectivePieceId}`);
    },
    ...options
  });
}
